'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('../constants');

var selfUtils = {};

/**
 * parses the relevant values for self: muted, guest, moderator, mediaStatus, state, joinedWith, creator, id
 * @param {Object} self
 * @param {String} deviceId
 * @returns {undefined}
 */
selfUtils.parse = function (self, deviceId) {
  if (self) {
    return {
      muted: selfUtils.getMuted(self),
      guest: self.guest,
      moderator: self.moderator,
      mediaStatus: selfUtils.getStatus(self.status),
      state: self.state,
      // TODO: give a proper name . With same device as login or different login`
      // Some times we might have joined with both mobile and web
      joinedWith: self.devices.some(function (device) {
        return deviceId === device.Url;
      }) ? _constants.SELF : _constants.OTHER,
      creator: self.isCreator, // check if its used,
      id: selfUtils.getId(self)
    };
  }
  return null;
};

selfUtils.getSelves = function (oldSelf, newSelf, deviceId) {
  var previous = oldSelf && selfUtils.parse(oldSelf, deviceId);
  var current = newSelf && selfUtils.parse(newSelf, deviceId);
  return {
    previous: previous,
    current: current,
    updates: {
      isUnadmittedGuest: selfUtils.isUnadmittedGuest(current),
      isAdmittedGuest: selfUtils.isAdmittedGuest(previous, current)
    }
  };
};

/**
 * get the id from the self object
 * @param {Object} self
 * @returns {String}
 */
selfUtils.getId = function (self) {
  if (!self || !self.person) {
    return null;
  }
  return self.person.id;
};

/**
 * get the muted property from the self object
 * @param {Object} self
 * @returns {Boolean}
 */
selfUtils.getMuted = function (self) {
  if (!self || !self.controls || !self.controls.audio) {
    return null;
  }
  return self.controls.audio.muted;
};

selfUtils.getStatus = function (status) {
  return {
    audio: status.audioStatus,
    video: status.videoStatus,
    slides: status.videoSlidesStatus
  };
};

/**
 * @param {Object} check
 * @returns {Boolean}
 */
selfUtils.isLocusGuestUnadmitted = function (check) {
  return check && check.guest && check.state === _constants.IDLE;
};

/**
 * @param {Object} check
 * @returns {Boolean}
 */
selfUtils.isLocusGuestAdmitted = function (check) {
  return check && check.guest && check.state === _constants.JOINED;
};

/**
 * @param {Object} self
 * @returns {Boolean}
 * @throws {Error} when self is undefined
 */
selfUtils.isUnadmittedGuest = function (self) {
  if (!self) {
    throw new TypeError('self must be defined to determine if self is unadmitted as guest.');
  }
  return selfUtils.isLocusGuestUnadmitted(self);
};

/**
 * @param {Object} oldSelf
 * @param {Object} changedSelf
 * @returns {Boolean}
 * @throws {Error} if changed self was undefined
 */
selfUtils.isAdmittedGuest = function (oldSelf, changedSelf) {
  if (!oldSelf) {
    // if there was no previous locus, it couldn't have been admitted yet
    return false;
  }
  if (!changedSelf) {
    throw new TypeError('New self must be defined to determine if self transitioned to admitted as guest.');
  }
  return selfUtils.isLocusGuestUnadmitted(oldSelf) && selfUtils.isLocusGuestAdmitted(changedSelf);
};

/**
 * extract the sipUrl from the partner
 * @param {Object} self
 * @param {Array} participants
 * @param {Object} info
 * @returns {Object}
 */
selfUtils.getSipUrl = function (self, participants, info) {
  var partner = participants.find(function (participant) {
    return self && participant.identity !== self.identity && (participants.length <= 2 || participant.type === _constants.USER && !participant.removed);
  });

  // For webex meeting the sipUrl gets updated in info parser
  if (partner && info.type === _constants.ONE_ON_ONE) {
    return { sipUri: partner.person.sipUrl || partner.person.emailAddress || partner.person.email };
  }
  return { sipUri: info.sipUri };
};

exports.default = selfUtils;
//# sourceMappingURL=selfUtils.js.map
